import { render, staticRenderFns } from "./become.vue?vue&type=template&id=20a98100&"
import script from "./become.vue?vue&type=script&lang=js&"
export * from "./become.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports